<template>
  <section id="admin-filter">
    <h4>Job Type filter</h4>
    <div class="form-group">
      <label for="jt-filter-code" class="form-label">Code</label>
      <input type="text" class="form-control" id="jt-filter-code" v-model="entity.code"/>
    </div>
    <div class="form-group">
      <label for="jt-filter-name" class="form-label">Name</label>
      <input type="text" class="form-control" id="jt-filter-name" v-model="entity.name"/>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  export default {
    name: 'JobTypeFilter',
    mixins: [ FilterMixin ],
    data () {
      return {
        entity: {
          code: '',
          name: ''
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// JobTypeFilter.vue?6ff4239c